// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBHTCfuHOxJNO3HvvtBhHTf2m9Orpsj29c',
    authDomain: 'dttd-company.firebaseapp.com',
    databaseURL: 'https://dttd-company.firebaseio.com',
    projectId: 'dttd-company',
    storageBucket: 'dttd-company.appspot.com',
    messagingSenderId: '176266046613',
    appId: '1:176266046613:web:b089e1caaa46d60d71ff9c',
    measurementId: 'G-CTSE9MQZDC'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
